import React from 'react';
import { HomeData, HomeImage } from '../../types/home';
import OptimizedImage from '../about/OptimizedImage';

interface AboutGroSectionProps {
  data: HomeData | null;
  logo: HomeImage | null;
  backgroundImage: HomeImage | null;
}

const AboutGroSection: React.FC<AboutGroSectionProps> = ({ data, logo, backgroundImage }) => {
  const aboutUrl = data?.field_link_url?.[0]?.uri?.replace("internal:", "");

  const handleButtonClick = () => {
    if (aboutUrl) {
      window.location.href = aboutUrl;
    }
  };
  // console.log(data);
  return (
    <>
    {/* // style={{ minHeight: "700px" }} */}
    <section id="aboutgro" className="aboutgro about-home-gro py-md-3 py-lg-5 section mt-3"  >
      <div className="aboutgroimg d-xl-block d-lg-block d-md-block d-sm-none">
        {backgroundImage && (
          <img
            src={backgroundImage?.thumbnail?.[0]?.url}
            className="img-fluid h-100  w-100"
            alt="About Gro Background"
            loading="lazy" 
           
          />
        )}
      </div>
      
      <div data-aos="fade-up">
        <div className="row gx-3">
          <div className="offset-xl-7 offset-md-6 text-sm-left  col-xxl-4 col-xl-4  col-lg-6 col-md-6 col-sm-12 px-md-4 px-sm-5">
            <label className="label-title">{data?.field_button_name?.[0]?.value}</label>
            <h6>
              {data?.field_description?.[0]?.value}
            </h6>
            
            {logo && (
              <OptimizedImage
                src={logo?.thumbnail?.[0]?.url}
                className="img-fluid mx-auto  py-lg-5 py-md-2 py-sm-5 py-5"
                alt="Gro Logo"
                loading="lazy"
              />
            )}
         
            <p dangerouslySetInnerHTML={{ __html: data?.field_content?.[0]?.value || '' }} />
            <div className="text-sm-centers">
            <button 
              type="button" 
              onClick={handleButtonClick}
              className="btn btn-sm btn-light"
              disabled={!aboutUrl}
            >
              {data?.field_link_url?.[0]?.title || 'Learn More'}
            </button>
            </div>
          </div>
        </div>
      </div>
    </section>
   
    </>
  );
};

export default AboutGroSection;
